import { Success, Failure, PromiseResult } from 'libs/apis/errors/Result';
import { AppError } from 'libs/apis/errors/AppError';
import type { GetProductOptionsResponse } from 'libs/apis/generated/models/GetProductOptionsResponse';
import { getProductOptions } from 'libs/apis';

export type FetchProductOptionsParams = {
  productId: number;
};

export const fetchProductOptions = (
  params: FetchProductOptionsParams
): PromiseResult<GetProductOptionsResponse, AppError> =>
  (async () => {
    try {
      const response = await getProductOptions({ productId: params.productId });
      return new Success(response);
    } catch (error) {
      return new Failure(new AppError((error as Error).message));
    }
  })();
